<template>
    <box-files :editing="$store.getters.isAdmin && $store.getters.isEditing" :folder-id="folderId" :sort="sort" :direction="direction" :limit="limit" :display="display"></box-files>
</template>
<script>
import { computed, ref, inject } from "vue";
import boxFiles from "@/components/webComponents/widget/boxFiles/boxFiles.vue";

export default {
    components: {
        boxFiles
    },
    props: {
        folder: {
            type: [String, Object],
            default: null
        },
        sort: {
            type: String,
            default: null
        },
        direction: {
            type: [String, Number, Boolean],
            default: null
        },
        limit: {
            type: [String, Number],
            default: null
        },
        display: {
            type: String,
            default: "Promo"
        }
    },
    setup(props, context) {
        const $json = inject("$json");

        const folderId = computed(() => {
            if ($json.packed(props.folder)) {
                return JSON.parse($json.unpack(props.folder)).id;
            } else {
                return props.folder.id;
            }
        });

        return {
            folderId
        };
    }
};
</script>
